import React, { useState, useEffect } from 'react';
import {
    Box,
    VStack,
    HStack,
    Select,
    Text,
    Divider,
    FormControl,
    Button,
    useToast,
} from '@chakra-ui/react';
import CustomInput from '../../../../components/common/CustomInput'; // Adjust the path if necessary
import CustomLabel from '../../../../components/common/CustomLabel'; // Adjust the path if necessary
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';
function LeftFormSection() {
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    const navigate = useNavigate()
    const [prefix, setPrefix] = useState('');
    const [name, setName] = useState('');
    const [ledgerGroup, setLedgerGroup] = useState('');
    const [address, setAddress] = useState('');
    const [place, setPlace] = useState('');
    const [mobile, setMobile] = useState('');
    const [taxId, setTaxId] = useState('');
    const [lgId, setLgId] = useState('');
    const [email, setEmail] = useState('');
    const [gpDays, setGpDays] = useState('');
    const [description, setDescription] = useState('');
    const [openingBalance, setOpeningBalance] = useState('');
    const [closingBalance, setClosingBalance] = useState('0');
    const [balanceTypeOpening, setBalanceTypeOpening] = useState('Dr');
    const [balanceTypeClosing, setBalanceTypeClosing] = useState('Dr');

    const p_id = sessionStorage.getItem('p_id');
    const cmp_id = sessionStorage.getItem('cmp_id');

    // Fetch data from the API
    useEffect(() => {
        const fetchPartyDetails = async () => {
            if (!p_id || !cmp_id) {
                toast({
                    title: "Error",
                    description: "Missing session data for p_id or cmp_id.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
                return;
            }

            try {
                const response = await axios.post(
                    `${ACCOUNTS_URL}/party/view_single_party.php`,
                    { p_id, cmp_id }
                );
                console.log('Response:', response);  // Log the full response

                // Log the success flag to check its exact value
                console.log('Success Flag:', response.data.success);

                // Compare with the appropriate type based on what you see in the logs
                if (response.data.success === true || response.data.success === 'true') {
                    const party = response.data.data;
                    console.log('Party Data:', party); // Log the actual party data

                    // Mapping API response to the state variables
                    setPrefix(party.prf_id === '1' ? 'Mr' : party.prf_id === '2' ? 'Ms' : 'Mrs');
                    setName(party.party_name || '');
                    setLedgerGroup(party.led_group_id || '');
                    setAddress(party.address1 || '');
                    setPlace(party.address2 || '');
                    setMobile(party.phone_no || '');
                    setTaxId(party.ti_no || '');
                    setLgId(party.ldg_id)
                    setEmail(party.email_id || '');
                    setGpDays(party.gp_days || '');
                    setDescription(party.description || '');
                    setOpeningBalance(party.L_opening_balance || '0');
                    setClosingBalance(party.L_closing_balance || '0');
                    setBalanceTypeOpening(party.balance_type_opening || 'Dr');
                    setBalanceTypeClosing(party.balance_type_closing || 'Dr');
                } else {
                    toast({
                        title: "Error",
                        description: response.data.message || "Failed to fetch data.",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    });
                }
            } catch (error) {
                console.error("Error fetching party details:", error);
                toast({
                    title: "Error",
                    description: "Failed to fetch party details.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        };

        fetchPartyDetails();
    }, [p_id, cmp_id, toast]);



    const resetForm = () => {
        setPrefix('');
        setName('');
        setLedgerGroup('');
        setAddress('');
        setPlace('');
        setMobile('');
        setTaxId('');
        setEmail('');
        setGpDays('');
        setDescription('');
        setOpeningBalance('');
        setClosingBalance('');
        setBalanceTypeOpening('Dr');
        setBalanceTypeClosing('Dr');
    };

    const updateCustomer = async () => {
        setLoading(true);
        const data = {
            ledger_id: lgId, // Assuming ledgerGroup is the ledger_id
            party_id: p_id, // Party ID from sessionStorage
            customer_name: name,
            ledger_group: ledgerGroup,
            ldg_id: lgId,
            led_discription: description,
            led_opbal: openingBalance,
            closing_bal: closingBalance,
            opbal_type: balanceTypeOpening === 'Dr' ? 1 : 2, // Dr is 1, Cr is 2
            cmp_id: cmp_id,
            user_id: sessionStorage.getItem('user_id'), // Assuming user_id is stored in sessionStorage
            cu_prifix: 1,
            cu_address: address,
            cu_place: place,
            cu_moble: mobile,
            cu_tin: taxId,
            cu_email: email,
            cu_gpdays: gpDays,
        };
        console.log('====================================');
        console.log(data);
        console.log('====================================');

        try {
            const response = await axios.put(
                `${ACCOUNTS_URL}/party/edit_party.php`,
                data
            );

            if (response.data.success === true || response.data.success === 'true') {
                toast({
                    title: "Success",
                    description: response.data.message || "Customer details updated successfully.",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
                navigate('/party/customer')
            } else {
                toast({
                    title: "Error",
                    description: response.data.message || "Failed to update customer details.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            console.error("Error updating customer:", error);
            toast({
                title: "Error",
                description: "Failed to update customer details.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setLoading(false);
        }
    };
    return (
        <Box
            as="form"
            bg="white"
            borderWidth="1px"
            p={6}
            style={{ borderRadius: '20px' }}
            w="100%"
            minH="750px"
        >
            <Text fontSize="2xl" mb={4}>
                Customers
            </Text>
            <Divider mb={4} />

            <VStack spacing={4} align="stretch">
                <HStack
                    spacing={4}
                    w="100%"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <FormControl w={{ base: '100%', md: '400px' }} isRequired>
                        <CustomLabel labelText="Prefix" />
                        <Select
                            name="prefix"
                            placeholder="Select Prefix"
                            value={prefix}
                            onChange={(e) => setPrefix(e.target.value)}
                        >
                            <option value="1">Mr</option>
                            <option value="2">Ms</option>
                            <option value="3">Mrs</option>
                        </Select>
                    </FormControl>

                    <FormControl isRequired w={{ base: '100%' }}>
                        <CustomLabel labelText="Name" />
                        <CustomInput
                            placeholder="Enter Name"
                            name="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </FormControl>

                    <FormControl isRequired w={{ base: '100%' }}>
                        <CustomLabel labelText="Ledger Group" />
                        <Select
                            name="ledgerGroup"
                            placeholder="Select Group"
                            value={ledgerGroup}
                            onChange={(e) => setLedgerGroup(e.target.value)}
                        >
                            <option value="31">Sundry Debtors</option>
                        </Select>
                    </FormControl>
                </HStack>

                <HStack
                    spacing={4}
                    w="100%"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <FormControl isRequired w={{ base: '100%' }}>
                        <CustomLabel labelText="Mobile No" />
                        <CustomInput
                            placeholder="Enter Mobile Number"
                            name="mobile"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                        />
                    </FormControl>

                    <FormControl isRequired w={{ base: '100%' }}>
                        <CustomLabel labelText="Email" />
                        <CustomInput
                            placeholder="Enter Email"
                            name="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </FormControl>
                </HStack>

                <HStack
                    spacing={4}
                    w="100%"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <FormControl w={{ base: '100%' }}>
                        <CustomLabel labelText="Address" />
                        <CustomInput
                            placeholder="Enter Address"
                            name="address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        />
                    </FormControl>

                    <FormControl w={{ base: '100%' }}>
                        <CustomLabel labelText="Place" />
                        <CustomInput
                            placeholder="Enter Place"
                            name="place"
                            value={place}
                            onChange={(e) => setPlace(e.target.value)}
                        />
                    </FormControl>
                </HStack>

                <HStack
                    spacing={4}
                    w="100%"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <FormControl w={{ base: '100%' }}>
                        <CustomLabel labelText="Tax ID" />
                        <CustomInput
                            placeholder="Enter Tax ID"
                            name="taxId"
                            value={taxId}
                            onChange={(e) => setTaxId(e.target.value)}
                        />
                    </FormControl>

                    <FormControl w={{ base: '100%' }}>
                        <CustomLabel labelText="GP Days" />
                        <CustomInput
                            placeholder="Enter GP Days"
                            name="gpDays"
                            type="number"
                            value={gpDays}
                            onChange={(e) => setGpDays(e.target.value)}
                        />
                    </FormControl>
                </HStack>

                <FormControl isRequired>
                    <CustomLabel labelText="Description" />
                    <CustomInput
                        placeholder="Enter Description"
                        name="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </FormControl>

                <HStack
                    spacing={4}
                    w="100%"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <FormControl w="100%">
                        <HStack
                            spacing={4}
                            w="100%"
                            flexDirection={{ base: 'column', md: 'row' }}
                            alignItems="flex-start"
                        >
                            {/* Opening Balance */}
                            <FormControl w={{ base: '100%', md: '40%' }}>
                                <CustomLabel labelText="Opening Balance" />
                                <CustomInput
                                    placeholder="0.00"
                                    name="openingBalance"
                                    value={openingBalance}
                                    onChange={(e) => setOpeningBalance(e.target.value)}
                                    textAlign="right"
                                />
                            </FormControl>

                            {/* Balance Type Opening */}
                            <FormControl w={{ base: '100%', md: '20%' }} mt={{ base: 2, md: 8 }}>
                                <Select
                                    name="balanceTypeOpening"
                                    value={balanceTypeOpening}
                                    onChange={(e) => setBalanceTypeOpening(e.target.value)}
                                >
                                    <option value="1">Dr</option>
                                    <option value="2">Cr</option>
                                </Select>
                            </FormControl>

                            {/* Closing Balance */}
                            <FormControl w={{ base: '100%', md: '40%' }}>
                                <CustomLabel labelText="Closing Balance" />
                                <CustomInput
                                    placeholder="0.00"
                                    name="closingBalance"
                                    value={closingBalance}
                                    onChange={(e) => setClosingBalance(e.target.value)}
                                    textAlign="right"
                                    isDisabled={true}
                                />
                            </FormControl>

                            {/* Balance Type Closing */}
                            <FormControl w={{ base: '100%', md: '20%' }} mt={{ base: 2, md: 8 }}>
                                <Select
                                    name="balanceTypeClosing"
                                    value={balanceTypeClosing}
                                    onChange={(e) => setBalanceTypeClosing(e.target.value)}
                                >
                                    <option value="1">Dr</option>
                                    <option value="2">Cr</option>
                                </Select>
                            </FormControl>
                        </HStack>
                    </FormControl>
                </HStack>


            </VStack>

            <Button
                mt={6}
                bg="#ff8f00"
                color='white'
                type="submit"
                isLoading={loading}
                isDisabled={loading}
                onClick={() => updateCustomer()}
            >
                Update Customer
            </Button>
        </Box>
    );
}

export default LeftFormSection;
